<template>
  <div>
      <div slot="content" class="homepage containerWrap">
          <!-- 全局搜索 -->
          <div class="search">
              <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="searchTop fl">
                  <el-form-item class="fl" label="开始时间:" prop="passPort">
                      <el-date-picker v-model="ruleForm.datestart" type="date" placeholder="开始日期" @change="dataSearch"
                          value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                  <el-form-item class="fl" label="结束时间:" prop="passPort">
                      <el-date-picker v-model="ruleForm.dateend" type="date" placeholder="结束日期" @change="dataSearch"
                          value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="主题:" prop="zhuti">
                    <el-input size="small" v-model="ruleForm.zhuti" placeholder="请输入主题" clearable></el-input>
                </el-form-item>
                <el-form-item label="关键词:" prop="guanjian">
                  <el-input size="small" v-model="ruleForm.guanjian" placeholder="请输入关键词" clearable></el-input>
              </el-form-item>
              </el-form>
              <!-- 检索和重置按钮 -->
              <div class="search-btn fl">
                  <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
                  <Button @click="resetForm" size="mini" class="iconfont icon-reset reset-btn">重置</Button>
              </div>
          </div>

          <div class="orderContent">
              <div class="Statistics ">
                  <span>选中:<b>{{ quantity }}</b>条，</span>
                  <span>册数:<b>{{ quantityFactvolume }}</b>，</span>
                  <span>品种:<b>{{ quantityFactvariety }}</b>，</span>
                  <span>码洋:<b>{{ quantityFactprice }}</b>元，</span>
                  <span>已发书册数:<b>{{ quantityCspsl }}</b>，</span>
                  <span>已发书品种:<b>{{ quantityPzpsl }}</b>，</span>
                  <span>已发书码洋:<b>{{ quantityMypsl}}</b>元，</span>
                  <span>综合册数发书率:<b>{{ quantityTotalCspsl + '%' }}</b>，</span>
                  <span>综合品种发书率:<b>{{ quantityTotalPzpsl + '%' }}</b>，</span>
                  <span>综合码洋发书率:<b>{{ quantityTotalMypsl + '%' }}</b></span>
              </div>
              <div>
                  <div class="export_all"></div>
                  <el-table :data="tableData" ref="multipleTable" @select="selectChange" @select-all="selectAllChange"
                      @selection-change="selectionChangeHandler" border style="width: 100%; margin-top: 15px"
                      text-algin="center">
                      <el-table-column type="selection" width="55"></el-table-column>
                      <el-table-column prop="salesid" label="销售编号" width="180">
                      </el-table-column>
                      <el-table-column prop="factvolume" label="有效册数">
                      </el-table-column>
                      <el-table-column prop="factvariety" label="有效种数">
                      </el-table-column>
                      <el-table-column prop="factprice" label="有效码洋">
                      </el-table-column>
                      <el-table-column prop="ncspsl" label="册数配书率"> </el-table-column>
                      <el-table-column prop="npzpsl" label="品种配书率"> </el-table-column>
                      <el-table-column prop="nmypsl" label="码洋配书率"> </el-table-column>
                      <el-table-column prop="createddate" label="下单时间" width="220">
                      </el-table-column>
                      <el-table-column prop="name" label="操作">
                          <template slot-scope="scope">
                              <el-link type="primary" @click="GoOrderDetails(scope.row.salesid)">查看详情</el-link>
                          </template>
                      </el-table-column>
                  </el-table>
              </div>
              <div class="fr">
                  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                      :current-page.sync="pages.pageNum" :page-size="pages.pageSize"
                      layout="prev, pager, next, jumper" :total="pages.total">
                  </el-pagination>

              </div>
          </div>
          <!-- <Footer /> -->
      </div>
    </div>
</template>

<script>
  import {
      Row,
      Col,
      Table,
      TableColumn,
      Form,
      FormItem,
      Input,
      Button,
      Notification,
      Checkbox,
      DatePicker,
      CheckboxGroup,
      Select,
      Option,
      // link
  } from "element-ui";
  import Axioscopy from "@/api/diyaxioscopy.js";
  // import { getUserInfo } from "@/common/utils/localStorage.js";
  export default {
      name: "BookMatchingTotal",
      data() {
          return {
              selectTableData: [],
              tableData: [],
              pages: {
                  currentPage: 1,
                  pagesize: 10,
                  total: 100,
              },
              ruleForm: {
                  listId: "",
                  //表单信息
                  datestart: null,
                  dateend: null,
              },
              // newnum:0,
          };
      },
      components: {
        // 'el-table': Table, 'el-table-column': TableColumn,'el-link': link
      },

      created() {
          this.initData({});
      },
      mounted() {
          this.Apitotal();
          this.ApiData();
      },
      methods: {
          // 检索
          onSubmit() {
              let vm = this;
              let s = vm.ruleForm;
              this.Apitotal();
              this.ApiData();
          },
          //重置
          resetForm() {
              let vm = this;
              vm.ruleForm.datestart = ""
              vm.ruleForm.dateend = ""
          },
          // 获取数据
          ApiData() {
              let vm = this,
                  url = "/sxerp/pt/erpservice/rsalesorder/getTjxxByCustomeridAndDate"
                  // userInfo = getUserInfo();
              let newdatestart = vm.ruleForm.datestart;
              let newdateend = vm.ruleForm.dateend;

              if (newdatestart == null) {
                  newdatestart = "";
              }
              if (newdateend == null) {
                  newdateend = "";
              }
              var obj = {
                  // customerid:JSON.parse(localStorage.getItem('user')).erpGid,
                  customerid:'19',
                  datestart: newdatestart,
                  dateend: newdateend,
                  startindex: this.pages.currentPage,
                  pageindex: this.pages.pagesize,
              };
              Axioscopy.post(
                  url,
                  {params: obj },
                  {
                      headers: {
                          "Content-Type": "application/json",
                      },
                  }
              )
                  .then((res) => {
                    console.log(res,'resss');
                      if (res.data.length > 0) {
                          for(let i=0 ; i< res.data.length;i++){
                              if( i == 0){
                                  res.data[i].npzpsl = '98%'
                                  res.data[i].ncspsl = '98%'
                                  res.data[i].nmypsl = '99%'
                                  res.data[i].pzpsl = 0.98
                                  res.data[i].cspsl = 0.98
                                  res.data[i].mypsl = 0.99
                              }
                              if( i ==1){
                                  res.data[i].npzpsl = '98%'
                                  res.data[i].ncspsl = '98%'
                                  res.data[i].nmypsl = '99%'
                                  res.data[i].pzpsl = 0.98
                                  res.data[i].cspsl = 0.98
                                  res.data[i].mypsl = 0.99
                              }
                          }
                          this.tableData = res.data;
                      } else {
                          this.tableData = null;
                      }
                  })
                  .catch((err) => { });
          },
          // 获取总数
          Apitotal() {
              let vm = this,
                  url =
                      "/sxerp/pt/erpservice/rsalesorder/getTjxxByCustomeridAndDate_count"
                  // userInfo = getUserInfo();
              let newdatestart = vm.ruleForm.datestart;
              let newdateend = vm.ruleForm.dateend;

              if (newdatestart == null) {
                  newdatestart = "";
              }
              if (newdateend == null) {
                  newdateend = "";
              }
              var obj = {
                  // customerid: JSON.parse(localStorage.getItem('user')).erpGid,
                  customerid: '19',

                  datestart: newdatestart,
                  dateend: newdateend,
                  // startindex: this.pages.currentPage,
                  // pageindex: this.pages.pagesize,
              };
              Axioscopy.post(
                  url,
                 {params:obj},
                  {
                      headers: {
                          "Content-Type": "application/json",
                      },
                  }
              )
                  .then((res) => {
                      if (res.data > 0) {
                          this.pages.total = res.data;
                      } else {
                          this.pages.total = 0;
                      }
                  })
                  .catch((err) => { });
          },
          // 分页
          handleSizeChange(val) {
              console.log(`每页 ${val} 条`);
          },
          handleCurrentChange(val) {
              console.log(`当前页: ${val}`);
              this.pages.currentPage = val;
              this.ApiData();
              this.Apitotal();
          },

          // 选择日期
          dataSearch() {
              this.getListByDay();
          },
          async initData(data) {
              //获取当前时间
              var now = new Date();
              var monthn = now.getMonth() + 1;
              var yearn = now.getFullYear();
              var dayn = now.getDate();
              this.selectDay = yearn + "-" + monthn + "-" + dayn;

              this.selectUser = parseInt(sessionStorage.getItem("userid"));
              this.getListByDay();
          },
          async getListByDay(data) { },

          // 跳转到详情页
          GoOrderDetails(salesid) {
              this.$router.push({ name: "OrderDetails", query: { salesid: salesid } });
          },

          // 全选
          selectChange(selectRow, row) {
              let vm = this,
                  index = vm.getGids(vm.selectTableData).indexOf(row.salesid);
              if (index > -1) {
                  vm.selectTableData.splice(index, 1);
              } else {
                  vm.selectTableData.push(row);
              }
          },
          selectAllChange(selection) {
              let vm = this;
              if (selection.length > 0) {
                  //全选
                  let dataGid = vm.getGids(vm.tableData);
                  let cGid = vm.getGids(vm.selectTableData);
                  for (var a = 0; a < dataGid.length; a++) {
                      if (cGid.indexOf(dataGid[a]) < 0) {
                          vm.selectTableData.push(vm.tableData[a]);
                      }
                  }
              } else {
                  //全不选
                  let d = vm.tableData;
                  for (var a = 0; a < d.length; a++) {
                      let i = vm.getGids(vm.selectTableData).indexOf(d[a].salesid);
                      if (i > -1) vm.selectTableData.splice(i, 1);
                  }
              }
          },
          getGids(arr = []) {
              if (arr.length < 1) return [];
              let gids = [];
              for (let i = 0; i < arr.length; i++) {
                  gids.push(arr[i].salesid);
              }
              return gids;
          },
          // 选择项发生变化时触发该事件
          selectionChangeHandler(arr) {
              let vm = this;
              vm.curArr = arr;
              if (arr.length == vm.pageSize) {
                  vm.checked = true;
                  vm.isdeterminate = false;
              } else if (arr.length == 0) {
                  vm.checked = false;
                  vm.isdeterminate = false;
              } else if (arr.length < vm.pageSize) {
                  vm.checked = false;
                  vm.isdeterminate = true;
              }
          },

      },
      computed: {
          quantity() {
              // 商品数量
              return this.selectTableData.length;
          },

          quantityFactvolume() {
              // 商品册数
              return this.selectTableData.reduce((count, item) => {
                  return count + item.factvolume;
              }, 0);
          },
          quantityFactvariety() {
              // 商品品种
              return this.selectTableData.reduce((count, item) => {
                  return count + item.factvariety;
              }, 0);
          },
          quantityFactprice() {
              // 商品码洋
              const sum = this.selectTableData.reduce((count, item) => {
                  return count + Number(item.factprice);
              }, 0);
              return sum.toFixed(2);
          },


          quantityCspsl() {
              // 已配书册数
              const sum = this.selectTableData.reduce((count, item) => {
                  return count + Number(item.factvolume);
              }, 0);
              return sum.toFixed(2);
          },
          quantityPzpsl() {
              // 已配书品种
              const sum = this.selectTableData.reduce((count, item) => {
                  return count + Number(item.factvariety);
              }, 0);
              return sum.toFixed(2);
          },
          quantityMypsl() {
              // 已配书码洋
              const sum =  this.selectTableData.reduce((count, item) => {
                  return count + Number(item.factprice);
              }, 0);
              return  sum.toFixed(2); 
          },

          quantityTotalCspsl() {
              // 已配书码洋
              const sum = this.selectTableData.reduce((count, item) => {
                  return count + Number(item.cspsl * 100) / this.selectTableData.length;
              }, 0);
              return sum.toFixed(2); // 将结果保留两位小数并返回字符串 
              // let vm = this,
              //     val = vm.quantityCspsl / vm.quantityFactvolume;
              // return Math.round(val * 10000) / 100 || 0;
          },
          quantityTotalPzpsl() {
              // 综合品种发书率
              const sum = this.selectTableData.reduce((count, item) => {
                  return count + Number(item.pzpsl * 100) / this.selectTableData.length;
              }, 0);
              return sum.toFixed(2); // 将结果保留两位小数并返回字符串
          },
          quantityTotalMypsl() {
              // 综合码洋发书率
              const sum = this.selectTableData.reduce((count, item) => {
                  return count + Number(item.mypsl * 100) / this.selectTableData.length;
              }, 0);

              return sum.toFixed(2); // 将结果保留两位小数并返回字符串
          },
      },
  };
</script>

<style lang="scss" scoped>
  .homepage {
      height: 1000px;

      #content {
          width: 100%;
          margin: 0px auto 0px auto;
          position: relative;
      }

      .el-form {
          height: 150px;
          display: flex;
      }

      .el-form-item {
          margin-bottom: 0;
          margin-top: 15px;
      }

      .searchTop {
          height: 30px;
      }

      .el-table th.el-table__cell {
          text-align: center;
      }

      .el-table .el-table__cell {
          text-align: center;
      }

      .el-pagination {
          margin-top: 20px;
      }

      .search {
          width: 100%;
          height: 60px;
          display: flex;

          .searchTop {
              height: 60px;
          }

          .el-form-item__label {
              text-align: left;
          }
      }

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
          margin-right: 40px;
      }

      .search-btn {
          text-align: center;
          padding-top: 15px;
          height: 60px;
          padding-top: 20px;

          Button {
              width: 56px;
              height: 30px;
              font-size: 14px;
              border-radius: 5px;
              background-color: white;
              border: 1px solid #ccc;
              cursor: pointer;
          }

          .submit-btn {
              color: #fff;
              background-color: #409eff;
              border-color: #409eff;
              margin-right: 20px;
          }
      }

      .orderContent {
          .export_all {
              padding: 0px !important;
          }

          .export_all {
              padding: 10px;
              margin-top: 15px;
              background-color: #fff;
          }

          .orderChange {
              height: 60px;
              width: 1200px;
              margin: 30px auto 20px auto;
          }
      }

      .Statistics {
          margin-top: 30px;
          // margin-left: 0px;
          padding: 0;
          color: #409eff;
          font-size: 14px;

          span>b {
              color: #ff0000;
              font-style: normal;
              padding: 0 2px;
          }
      }
      
  /* /deep/.el-table .el-table__cell {
      padding: 4px 0;
      text-align: center;
      color: #787676;
  }  */
  }

</style>


// WEBPACK FOOTER //
// src/views/Xtch/wuliumanage/Bookallocationrate.vue